export const isGuestAccount = (session) => {
  if (session) {
    const {
      user: { name, email },
    } = session
    if (name === 'Vieras' && email === 'vieras@happens.fi') {
      return true
    }
  }

  return false
}

export default {
  isGuestAccount,
}
